import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const list = Object.freeze([
  {
    id: '1',
    label: 'FORMULA 1 - ASSE EREDITARIO INFERIORE',
    value:
      "Dichiaro inoltre che il defunto non ha lasciato un asse ereditario superiore ai  50 milioni, ne' beni immobili ne' diritti reali  immobiliari.  ",
  },
  {
    id: '2',
    label: 'FORMULA 2 - ASSE EREDITARIO SUPERIORE',
    value:
      "Dichiaro inoltre che il defunto ha lasciato  un  asse  ereditario  superiore ai 50  milioni,  pertanto  il  rimborso    da    parte   dell'USL  ........ regolarmente  inserito  nella  denuncia  di  successione  all'Ufficio Imposte.",
  },
  {
    id: '3',
    label: 'FORMULA 3 -NON ERA RICOVERATO',
    value:
      'Dichiaro inoltre che il defunto, alla data del decesso  non  era  ricoverato in istituto a totale o parziale carico di Ente Pubblico.',
  },
  {
    id: '4',
    label: 'FORMULA 4 -ERA RICOVERATO',
    value:
      'Dichiaro inoltre che il defunto,  alla  data  del  decesso  era  ricoverato  in  istituto a totale o parziale carico di',
  },
  {
    id: '5',
    label: 'FORMULA 5 - RICHIEDENTE + NON HA LASCIATO ALTRI FIGLI',
    value:
      "e di me ........ .............................................................. che .. defunt. ................................................................non   ha   lasciato   altri   figli   legittimi   oltre    quelli   suindicati,  quali  non   sono   inabili,  ne'  interdetti,      ne'      ha      lasciato      figli  naturali    riconosciuti,      adottivi,      affidati    o    giudizialmente   dichiarati.",
  },
  {
    id: '6',
    label: 'FORMULA 6 RICHIEDENTE + NON HA LASCIATO FIGLI',
    value:
      "e di me ........ ..............................................................che .. defunt. ................................................................non   ha   lasciato   figli   legittimi,  ne'  ha   lasciato   figli   naturali riconosciuti,   adottivi,   affidati  o  giudizialmente   dichiarati.",
  },
  {
    id: '7',
    label: 'FORMULA 7 - NON HA LASCIATO ALTRI FIGLI',
    value:
      "che  il suddetto defunto  non ha lasciato  altri figli legittimi  oltre  quelli suindicati,  i quali non sono inabili,  ne' interdetti,  ne' ha lasciato  figli  naturali  riconosciuti,   adottivi,   affidati  o  giudizialmente   dichiarati.",
  },
  {
    id: '8',
    label: 'FORMULA 8 - MATRIMONIO SENZA SEPARAZIONE',
    value:
      "che  fra  ...  coniugi  non  esisteva  separazione  di  fatto  ne'  separazione  consensuale  omologata  o  separazione  giudiziale,  ne' pendeva   giudizio  di  scioglimento  o  annullamento  del  matrimonio  contratto  in  data  ../../....a ",
  },
  {
    id: '9',
    label: 'FORMULA 9 - SEPARAZIONE DI FATTO',
    value:
      'che fra ... coniugi esisteva separazione di fatto per ......................... del matrimonio contratto in data ../../.... a ............................. ...',
  },
  {
    id: '10',
    label: 'FORMULA 10 - SEPARAZIONE LEGALE',
    value:
      'che fra ... coniugi esisteva  separazione  legale  con  sentenza n. ..........del ../../.... del Tribunale di ........................................... ...del matrimonio contratto in data ../../.... a ............................. ..',
  },
  {
    id: '11',
    label: 'FORMULA 11 - SEPARAZIONE CONSENSUALE OMOLOGATA',
    value:
      'che fra ... coniugi esisteva  separazione  consensuale  omologata n. ..........del ../../.... del Tribunale di ........................................... ...del matrimonio contratto in data ../../.... a ................................',
  },
  {
    id: '12',
    label: 'FORMULA 12 - SCIOGLIMENTO DEL MATRIMONIO',
    value:
      'che  fra  ...  coniugi  esisteva   scioglimento  del  matrimonio  con  sentenza n. .......... del ../../.... del Tribunale di ............................. ... del matrimonio contratto in data ../../.... a ............................. ...',
  },
  {
    id: '13',
    label: 'FORMULA 13 - CESSAZIONE EFFETTI CIVILI',
    value:
      'esiste cessazione degli effetti civili del matrimonio con sentenza n. ......... del ../../.... del Tribunale di ........................................... ...',
  },
]);

export interface FormulaItemVM {
  id: string;
  label: string;
  value: string;
}

interface FormulaListProps {
  disabled?: boolean;
  value?: Array<FormulaItemVM>;
  onChange: (item?: Array<FormulaItemVM>) => void;
  error?: boolean;
  label?: string;
}

const FormulaListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Formula',
}: FormulaListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id={`label-${label}`}>{label}</InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={value?.map((element) => element.id) || []}
        label={label}
        onChange={(event) => {
          const { value: valueEvent } = event.target;

          const valueTofind =
            typeof valueEvent === 'string' ? valueEvent.split(',') : (valueEvent as string[]);
          const element = valueTofind;
          const foundElement = list.filter((el) => element.find((el1) => el1 === el.id));
          onChange(foundElement);
        }}
        disabled={disabled}
        error={error}
        multiple
      >
        {list.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

FormulaListComponent.displayName = 'Formula lista component';

const FormulaList = memo(FormulaListComponent);

export default FormulaList as typeof FormulaListComponent;
